function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0714 11.4939V23.0737H0.927734V19.2138L26.0714 11.4939ZM25.6691 3.85115L19.6095 0.505859L20.6655 4.08275L7.94282 7.9427C7.65991 7.54787 7.30371 7.214 6.89461 6.96018C6.48551 6.70636 6.03152 6.53758 5.55862 6.46349C5.08573 6.3894 4.6032 6.41145 4.13863 6.52839C3.67407 6.64533 3.2366 6.85485 2.85123 7.14498C2.46544 7.43452 2.13921 7.79907 1.8912 8.21776C1.6432 8.63646 1.47828 9.10108 1.40589 9.58506C1.3335 10.069 1.35504 10.5629 1.4693 11.0383C1.58356 11.5138 1.78829 11.9615 2.07177 12.3559C3.25353 14.0286 5.5416 14.376 7.16337 13.1536C8.05597 12.4974 8.59656 11.4553 8.64685 10.323L21.3695 6.46306L22.4256 10.0399L25.6691 3.85115Z",
  fill: "current"
});

function SvgLength(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLength);
export default __webpack_public_path__ + "static/media/length.bdae10bd.svg";
export { ForwardRef as ReactComponent };